import React from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { showCookieBanner } from "components/common/CookieConsentBanner";
import styles from "./footerNav.module.scss";

interface NavLink {
    label: string;
    to: string;
    external?: boolean;
    comingSoon?: boolean;
    onClick?: (e: React.MouseEvent) => void;
}

const FooterNav = () => {
    const { t } = useTranslation();

    const columns: NavLink[][] = [
        [
            { label: t("footer.contacts"), to: "/contacts" },
            // { label: t("footer.faq"), to: "/faq" },
        ],
        [
            { label: t("footer.siteRules"), to: "https://io.activecloud.com/production-blago-pro/public-docs/user_rules.pdf", external: true },
            { label: t("footer.publicContract"), to: "https://io.activecloud.com/production-blago-pro/public-docs/ads-agreement.pdf", external: true },
            { label: t("footer.tariffs"), to: "https://io.activecloud.com/production-blago-pro/public-docs/ads-price.pdf", external: true },
        ],
        [
            { label: t("footer.cookieSettings"), to: "#", onClick: (e: React.MouseEvent) => { e.preventDefault(); showCookieBanner(); } },
            { label: t("footer.cookiePolicy"), to: "https://io.activecloud.com/production-blago-pro/public-docs/cookie.pdf", external: true },
            { label: t("footer.personalDataProcessing"), to: "https://io.activecloud.com/production-blago-pro/public-docs/extra-policy.pdf", external: true },
            { label: t("footer.personalDataPolicy"), to: "https://io.activecloud.com/production-blago-pro/public-docs/policy.pdf", external: true },
        ],
    ];

    const handleComingSoon = (e: React.MouseEvent) => {
        e.preventDefault();
        toast.info(t("footer.comingSoon"));
    };

    return (
        <nav className={styles.root}>
            {columns.map((column, colIndex) => (
                <div key={colIndex} className={styles.column}>
                    {column.map((link) => {
                        if (link.onClick) {
                            return (
                                <a
                                    key={link.label}
                                    href="#"
                                    onClick={link.onClick}
                                    className={styles.link}
                                >
                                    {link.label}
                                </a>
                            );
                        }

                        if (link.comingSoon) {
                            return (
                                <a
                                    key={link.label}
                                    href="#"
                                    onClick={handleComingSoon}
                                    className={styles.link}
                                >
                                    {link.label}
                                </a>
                            );
                        }

                        if (link.external) {
                            return (
                                <a
                                    key={link.to}
                                    href={link.to}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.link}
                                >
                                    {link.label}
                                </a>
                            );
                        }

                        return (
                            <Link key={link.to} to={link.to} className={styles.link}>
                                {link.label}
                            </Link>
                        );
                    })}
                </div>
            ))}
        </nav>
    );
};

export default FooterNav;